import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import HelloController from "./controllers/hello_controller"
import DropdownController from "./controllers/dropdown_controller"
import EditorController from "./controllers/editor_controller"
import ThemeController from "./controllers/theme_controller"

const application = Application.start()
application.debug = false
window.Stimulus = application

application.register("hello", HelloController)
application.register("dropdown", DropdownController)
application.register("editor", EditorController)
application.register("theme", ThemeController)
